import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { useAppSelector } from "../../app/hooks";

export interface userViewState
{
    userViewOverride: boolean;
}

const initialUserViewState: userViewState = {
    userViewOverride: false,
};

// This slice exists because the useIdentity hook is actually localized per component, and not global data. Therefore, in order
// to effectively override it we need to pull this flag from the global data store in redux and pass it in at the component level
export const userViewOverrideSlice = createSlice( {
    name: "mobile",
    initialState: initialUserViewState,
    reducers: {
        setUserViewOverride( state, action: PayloadAction<boolean> )
        {
            state.userViewOverride = action.payload;
        },
    },
} );


export const selectUserViewOverride = ( state: RootState ) => state.userViewOverride.userViewOverride;
export const useUserViewOverride = () => useAppSelector( selectUserViewOverride );
export const { setUserViewOverride } = userViewOverrideSlice.actions;
export default userViewOverrideSlice.reducer;
